/**
 * 公共接口
 */
import axios from "../../utils/axios";

// 获取运营状态列表
export function getRunningStates(data) {
    return axios({
        url: "/admin/common/asin_common/get_running_states",
        method: "post",
        data: data
    });
}


// 获取运输模式列表
export function get_all_deliver_modes(data) {
    return axios({
        url: "/admin/common/asin_common/get_all_deliver_modes",
        method: "post",
        data: data
    });
}

